import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../auth/AuthContext';

const API_BASE = import.meta.env.VITE_API_URL || `http://${window.location.hostname}:7070`;
const DISMISS_KEY = 'vq_verify_banner_dismissed_at';
const REAPPEAR_MS = 6 * 60 * 60 * 1000;

export default function EmailVerificationBanner() {
  const { t } = useTranslation();
  const { user, token } = useAuth();
  const [dismissed, setDismissed] = useState(() => {
    const at = Number(localStorage.getItem(DISMISS_KEY) || 0);
    return at && Date.now() - at < REAPPEAR_MS;
  });
  const [resend, setResend] = useState('idle');

  if (!user || user.emailVerified || user.role === 'ADMIN' || dismissed) return null;

  const handleResend = async () => {
    setResend('sending');
    try {
      const res = await fetch(`${API_BASE}/api/v1/auth/resend-verification`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
      });
      setResend(res.ok ? 'sent' : 'error');
    } catch {
      setResend('error');
    }
  };

  const handleDismiss = () => {
    localStorage.setItem(DISMISS_KEY, String(Date.now()));
    setDismissed(true);
  };

  return (
    <div style={s.banner}>
      <span style={s.icon}>⚠</span>
      <span style={s.text}>{t('verifyBanner.text')}</span>
      <button type="button" onClick={handleResend} disabled={resend === 'sending' || resend === 'sent'} style={s.action}>
        {resend === 'sent' ? t('verifyBanner.resent')
          : resend === 'sending' ? t('verifyBanner.resending')
          : t('verifyBanner.resend')}
      </button>
      <button type="button" onClick={handleDismiss} aria-label={t('verifyBanner.dismissAria')} style={s.close}>×</button>
    </div>
  );
}

const s = {
  banner: {
    display: 'flex', alignItems: 'center', gap: 10,
    padding: '10px 16px', background: 'rgba(245,158,11,0.1)',
    borderBottom: '1px solid rgba(245,158,11,0.35)', color: '#FDE68A',
    fontSize: '0.88rem', fontFamily: 'system-ui, sans-serif',
  },
  icon: { fontSize: '1rem' },
  text: { flex: 1 },
  action: {
    background: 'transparent', border: '1px solid rgba(245,158,11,0.5)',
    color: '#FDE68A', padding: '4px 10px', borderRadius: 6,
    fontSize: '0.8rem', fontWeight: 600, cursor: 'pointer',
  },
  close: {
    background: 'transparent', border: 'none', color: '#FDE68A',
    fontSize: '1.15rem', cursor: 'pointer', padding: '0 4px',
  },
};
